import { Box, Typography } from '@mui/material';

import { FactsheetDetails } from '@/pages/Facthsheets/constants';

const CriteriaTab = ({ factsheet }: { factsheet: FactsheetDetails }) => {
  let criteriaParsedLines: string[] = [];
  if (
    factsheet.factsheetVersionHistory.length > 0 &&
    factsheet.factsheetVersionHistory[0].criteriaForInclusion
  ) {
    criteriaParsedLines = factsheet.factsheetVersionHistory[0]?.criteriaForInclusion?.split('\n');
  }

  return (
    <Box>
      {criteriaParsedLines.map(criteriaLine => {
        return (
          <Typography
            key={criteriaLine}
            sx={{
              fontSize: 16,
              fontWeight: 500,
              mb: 0.5
            }}
          >
            {criteriaLine}
          </Typography>
        );
      })}
    </Box>
  );
};
export default CriteriaTab;
